import React from 'react'
import { connect } from 'react-redux'
import styles from './Users.module.css'
import orderBy from 'lodash/orderBy'
import {Header} from './Header'
import Spinner from './Spinner'
import add from '../images/add.svg'
import { Button, Input, FormGroup, Label } from 'reactstrap'
import { Dialog, DialogContent, DialogFooter, DialogHeader } from './Dialog'
// @ts-expect-error
import { Helmet } from 'react-helmet'
import Footer from './Footer'
import { fetchProjects } from '../redux/projects'
import { fetchUsers, createUser } from '../redux/users'
import BackButton from './BackButton'
import {mergeClasses} from '../helpers/styling'
import cssFix from './mui/resolutions.module.css'
import { useHistory } from 'react-router-dom'
import { useWistorAuth } from '../api/auth'
import { useSelector } from '../store'

type State = {
  dialogVisible: boolean
  values: Partial<Record<'name' | 'email' | 'password' | 'role' | 'project', string>>,
}

function Users(props: {
  fetchUsers: typeof fetchUsers,
  fetchProjects: typeof fetchProjects,
  createUser: typeof createUser,
}) {
  const [state, setState] = React.useState<State>({values: {}, dialogVisible: false})
  const history = useHistory()
  const auth = useWistorAuth()

  const store = useSelector(s => ({users: s.users, projects: s.projects}))

  const gotoLogin = () => history.push('/login', 'users')

  React.useEffect(() => {
    if (auth.status !== 'authorized') return gotoLogin()

    props.fetchProjects((error: any) => {
      if (error.response.status === 401) gotoLogin()
    })
    props.fetchUsers((error: any) => {
      if (error.response.status === 401) gotoLogin()
    })
  }, [])

  if (auth.status !== 'authorized') {
    gotoLogin()
    return null
  }


  const onDialogOkClick = () => {
    props.createUser(state.values, (error: any) => {
      alert('User could not be created. Refresh the page and try again. Contact us if you need further assistance.')
  })
    setState(s => ({...s, dialogVisible: false }))
  }

    if (store.users.loading || store.projects.loading)
      return <Spinner />
    if (!store.projects.loaded || !store.users.loaded) return null

    let users = store.users.items
    let projects = store.projects.items
    // users = orderBy(users, ['createdAt'], ['asc']);
    users = orderBy(users, ['name'], ['asc'])
    const isSuperadmin = auth.user.role === 'superadmin'
    return (
      <div>
        <Helmet>
          <title>Wistor Apps</title>
          <link rel="icon" type="image/png" href="/favicon.png" sizes="16x16" />
        </Helmet>
        <BackButton />
        <Header />

        <div className={styles.mainContainer}>
          <div className={styles.main}>
            <div className={styles.content}>
              <div className={styles.title}>Users</div>
              <div className={styles.users}>
                <div className={styles.tableContainer}>
                  <table>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        {isSuperadmin && <th>Project</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((user: any) => {
                        return (
                          <tr className={styles.user} key={user.id}>
                            <td
                              style={{ fontSize: '1.1em', fontWeight: '500' }}
                            >
                              {user.name}
                            </td>
                            <td>{user.email}</td>
                            <td>{user.role}</td>
                            {isSuperadmin && (<td>{user.project && user.project.title}</td>)}
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>

                <div className={styles.add} onClick={() => setState(s => ({...s, dialogVisible: true }))}>
                  <div>
                    <img className="inline" src={add} alt="add" style={{ width: '24px' }} />
                    <span style={{ verticalAlign: 'middle', paddingLeft: '12px' }}>
                      Create a new user...
                    </span>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <Footer />
        </div>

        {state.dialogVisible && (
          <Dialog onClose={() => setState(s => ({ ...s, dialogVisible: false }))}>
            <DialogHeader title="Add user" />
            <DialogContent>
              <FormGroup>
                <Label>Name</Label>
                <Input
                  className="dark-form-control"
                  value={state.values.name || ''}
                  type="text"
                  onChange={(e) =>
                    setState(s => ({...s,
                      values: { ...s.values, name: e.target.value }}))}
                    />

              </FormGroup>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  className="dark-form-control"
                  value={state.values.email || ''}
                  type="text"
                  onChange={(e) =>
                    setState(s => ({...s,
                      values: { ...s.values, email: e.target.value }}))
                  }
                />
              </FormGroup>
              <FormGroup>
                <Label>Password</Label>
                <Input
                  className="dark-form-control"
                  value={state.values.password || ''}
                  type="text"
                  onChange={(e) =>
                    setState(s => ({...s,
                      values: { ...s.values, password: e.target.value }}))
                  }
                />
              </FormGroup>
              <FormGroup>
                <Label>Role</Label>
                <Input
                  className={mergeClasses("dark-form-control", cssFix["dark-form-control-select"])}
                  value={state.values.role || ''}
                  type="select"
                  onChange={(e) =>
                    setState(s => ({...s,
                      values: { ...s.values, role: e.target.value }}))}
                    >

                  <option value="">Choose a role</option>
                  <option value="viewer">Viewer</option>
                  <option value="editor">Editor</option>
                  <option value="admin">Administrator</option>
                  {isSuperadmin && (<option value="superadmin">SuperAdministrator</option>)}
                </Input>
              </FormGroup>
              {isSuperadmin && (
                <FormGroup>
                  <Label>Project</Label>
                  <Input
                    className={mergeClasses("dark-form-control", cssFix["dark-form-control-select"])}
                    value={state.values.project || ''}
                    type="select"
                    onChange={(e) =>
                      setState(s => ({...s,
                        values: { ...s.values, project: e.target.value }}))}
                      >

                    <option value="">Choose a project</option>
                    {projects.map((project: any) => (
                      <option key={project.id} value={project.id}>
                        {project.title}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              )}
            </DialogContent>
            <DialogFooter>
              <Button
                color="secondary"
                style={{ minWidth: '120px' }}
                onClick={() => setState(s => ({...s, dialogVisible: false }))}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                style={{ minWidth: '120px' }}
                onClick={onDialogOkClick}
              >
                OK
              </Button>
            </DialogFooter>
          </Dialog>
        )}
      </div>
    )
}

export default connect(undefined, {
  fetchProjects,
  fetchUsers,
  createUser,
})(Users as any)
